import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { Dialog } from 'primereact/dialog';
import Wrapper from '../layouts/Wrapper';
import BannerTemplate from '../components/BannerTemplate';
import SectionsInfo from '../components/SectionsInfo';
import useWindowSize from '../hooks/useWindowSize';
import { getCertificatesPage } from '../store/actions/certificatesPage';
import Spinner from '../components/Spinner';
import removeHtmlTags from '../helpers/removeHtmlTags';
import fIcon from '../assets/icons/fullScreen.svg';
import closeIcon from '../assets/icons/closeIcon.svg';

function Certificates() {
  const { width } = useWindowSize();
  const dispatch = useDispatch();
  const lang = Cookies.get('i18next') || 'en';
  const { data, loading } = useSelector((state) => state.certificatesPage);
  const [selectedImageSrc, setSelectedImageSrc] = useState('');
  useEffect(() => {
    dispatch(getCertificatesPage());
  }, []);
  return (
    <Wrapper>
      {!loading ? (
        <>
          <Dialog
            style={{
              width: '90vw',
              height: width > 768 ? '90vh' : '50vh',
            }}
            dismissableMask
            closeOnEscape
            closeIcon={() => <img src={closeIcon} alt="close icon" />}
            draggable={false}
            position="center"
            header=""
            headerClassName="bottom-popup-header"
            className="bottom-popup"
            maskStyle={{
              background: 'rgba(0, 0, 0, 0.60)',
              width: '100%',
            }}
            visible={selectedImageSrc}
            onHide={() => { if (!selectedImageSrc) return; setSelectedImageSrc(''); }}
          >
            <img className="cartificate-big-image" src={selectedImageSrc} alt="" />
          </Dialog>
          <div className="container medium">
            <BannerTemplate
              isCertificates
              extraClass="certificates-banner"
              title={data.certificatesDescription.title[lang]}
              description={removeHtmlTags(data.certificatesDescription.body[lang])}
            />
            <div className="certificates-content">
              <SectionsInfo
                isSlider={false}
                isPartner={false}
                title={data.certificatesDescription.two_blog_title[lang]}
                description={
                  removeHtmlTags(data.certificatesDescription.two_blog_description[lang])
}
              />
              <div className="certificates-list">
                {data.certificates.map((e) => (
                  <div
                    role="presentation"
                    onClick={() => {
                      if (width > 768) return null;
                      return setSelectedImageSrc(e.image.webp_url);
                    }}
                    key={e.id}
                    className="certificates-item"
                  >
                    <button
                      type="button"
                      onClick={() => setSelectedImageSrc(e.image.webp_url)}
                      className="certificates-item_overlay"
                    >
                      <img src={fIcon} alt="See full" />
                    </button>
                    <img src={e.image.webp_url} alt="certificate" />
                    {width > 768 && <p>{e.title[lang]}</p>}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </>
      ) : <Spinner width={100} height={100} />}
    </Wrapper>
  );
}

export default Certificates;
